module.exports = __webpack_public_path__ + "assets/logo.bc7f21ae.svg";